import { Nav } from 'react-bootstrap';

function SingleViewPageTabs({ activeTab, onTabSelect, tabHeaders }) {

  return (
    <Nav variant="tabs" activeKey={activeTab} onSelect={onTabSelect} className="mb-3">
      {tabHeaders?.map((tab) => (
        <Nav.Item key={tab.key}>
          <Nav.Link eventKey={tab.key} style={{ textDecoration: 'none' }}>{tab.label}</Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  )
}

export default SingleViewPageTabs;